import { OverviewMap, ScaleLine } from "ol/control";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";

class MapControlsService {

    addOverviewMap(map) {
        const overview = new OverviewMap({
            layers: [
                new TileLayer({
                    source: new OSM()
                })
            ],
            collapsed: false,
            collapsible: false,
            className: "ol-overviewmap ol-custom-overviewmap"
        });

        map.addControl(overview);
    }

    addScaleLine(map) {
        const scale = new ScaleLine();
        map.addControl(scale);
    }

    addDefaultControls(map) {
        this.addOverviewMap(map);
        this.addScaleLine(map);
    }

}

export const mapControlsService = new MapControlsService();
